import React, { useEffect, useState } from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { useDispatch, useSelector } from "react-redux";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { BandsTypes } from "../../Banding/Types";
import { FetchBandingDetails } from "../Script";
import { useUser } from "../../../../../AuthContext";
import { OutputMappingAgeFormView } from "./OutputMappingAgeForm.view";
import { BandFormTypes } from "./Types";

/**
 * Responsible for age popup logic
 */
export const OutputMappingAgeForm: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const configId = outputConfig.selectedOutputConfig.id;
  const [data, setData] = useState<BandFormTypes[]>([]);
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  useEffect(() => {
    (async (): Promise<void> => {
      const res = await FetchBandingDetails(
        configId,
        BandsTypes.AGE.toLowerCase(),
        translate,
        dispatch,
        env,
        user?.token
      );
      setData(res);
    })();
  }, []);

  return (
    <OutputMappingAgeFormView
      configId={configId}
      data={data}
    />
  );
};
